import React from 'react';

import styles from './GroupValidationMessage.module.css';

/**
 * Renders a single-line red validation message under a group of paired
 * inputs. Meant to be placed as a sibling below the input row inside a
 * vertical flex wrapper (e.g. `.group` in the flow's input modules), so
 * the input row stays a stable one-line layout and only this element
 * appears / disappears when the error toggles.
 *
 * Returns `null` for empty / falsy messages — the parent doesn't need to
 * conditionally render it.
 *
 * `role="alert"` + `aria-live="polite"` gives screen readers the message
 * once when it materialises, without hijacking focus.
 *
 * @param {{
 *   message?: string,
 *   testId?: string,
 * }} props
 */
const GroupValidationMessage = ({ message, testId }) => {
	if (!message) return null;
	return (
		<div className={styles.groupError} data-testid={testId} role="alert" aria-live="polite">
			{message}
		</div>
	);
};

export default GroupValidationMessage;
